var map = {
	"./gmdl_icon1.png": "75fa",
	"./gmdl_icon2.png": "8541",
	"./gmdl_icon3.png": "6ba2",
	"./gmdl_icon4.png": "d9d3",
	"./gmdl_icon5.png": "c6ff",
	"./gmdl_icon6.png": "6b20"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f2e8";